/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
if (process.env.NODE_ENV === 'development') {
    require('./src/styles/main.scss');
}

const getLegacyProjectsRedirectPath = pathname => {
    const allMatch = pathname.match(/^\/projects\/category\/all(?:\/([0-9]+))?\/?$/);

    if (allMatch) {
        return allMatch[1] ? `/projects/${allMatch[1]}/` : '/projects/';
    }

    const categoryMatch = pathname.match(/^\/projects\/category\/([^/]+)(?:\/([0-9]+))?\/?$/);

    if (categoryMatch) {
        return categoryMatch[2] ? `/projects/${categoryMatch[1]}/${categoryMatch[2]}/` : `/projects/${categoryMatch[1]}/`;
    }

    return null;
};

const getLegacyBlogRedirectPath = pathname => {
    const categoryMatch = pathname.match(/^\/blog-posts\/category\/all(?:\/([0-9]+))?\/?$/);

    if (categoryMatch) {
        return categoryMatch[1] ? `/blog/${categoryMatch[1]}/` : '/blog/';
    }

    const postMatch = pathname.match(/^\/blog-posts\/([^/]+)\/?$/);

    if (!postMatch) {
        return null;
    }

    return `/blog/${postMatch[1]}/`;
};

exports.onPreRouteUpdate = ({ location, prevLocation }) => {
    const redirectPath = getLegacyProjectsRedirectPath(location.pathname) || getLegacyBlogRedirectPath(location.pathname);

    if (redirectPath) {
        window.location.replace(redirectPath);
        return;
    }

    const isChangePage = prevLocation && prevLocation.pathname !== location.pathname;
    document.documentElement.classList.toggle('scroll-smooth', !isChangePage);

    setTimeout(() => document.documentElement.classList.add('scroll-smooth'), 50);
}
